// trip-confirmation-modal.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,IconButton
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";


interface TripConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onCancel:() => void;
  onConfirm: () => void;
  type: 'start' | 'end';
  companyName?: string;
  ofdCount?: string;
}

const TripConfirmationModal: React.FC<TripConfirmationModalProps> = ({
  open,
  onClose,
  onCancel,
  onConfirm,
  type,
  companyName,
  ofdCount
}) => {
  const getTitle = () => {
    return type === 'start' ? 'Start Trip Confirmation' : 'Handover Confirmation';
  };

  const getContent = () => {
    if (type === 'start') {
      return `Do you want to start the assigned trip (${companyName}) or begin a new trip?`;
    } else {
      return `There are ${ofdCount} orders pending for delivery. Are you sure you want to handover the orders?`;
    }
  };

  return (
<Dialog
  open={open}
  onClose={(event, reason) => {
    if (reason !== "backdropClick") {
      onClose();
    }
  }}
  aria-labelledby="trip-confirmation-dialog-title"
>

<DialogTitle
  id="trip-confirmation-dialog-title"
  sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}
>
  {getTitle()}
  <IconButton
    aria-label="close"
    onClick={onClose}
    sx={{
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <CloseIcon />
  </IconButton>
</DialogTitle>


      <DialogContent>
        <Typography>
          {getContent()}
        </Typography>
      </DialogContent>
      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
        {type === 'start' ? (
          <>
            <Button onClick={onCancel} className="custom-cancel-button" >
              Start New Trip
            </Button>
            <Button onClick={onConfirm} sx={{backgroundColor:"green", color:'white', "&:hover": {
      backgroundColor: "green"
    },}} >
              Start Assigned Trip
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onCancel}className="custom-cancel-button" >
              Cancel
            </Button>
            <Button onClick={onConfirm} sx={{backgroundColor:'#DC8A17', color:'white',"&:hover": {
      backgroundColor: "#DC8A17"
    },}} autoFocus>
              Handover
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default TripConfirmationModal;
